import { Box, FormControlLabel, Switch, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ISetupPdfMessages } from '../../../../types/setupPDFTypes';
import { styles } from './Watermark.styles';

const MAX_WATERMARK_LENGTH = 20;
export const Watermark = ({
  messages,
  watermark,
  onWatermarkChange
}: {
  messages: ISetupPdfMessages;
  watermark: string | null;
  onWatermarkChange: (value: string | null) => void;
}) => {
  const [isWatermarkEnabled, setIsWatermarkEnabled] = useState(watermark !== null && watermark !== '');
  const [value, setValue] = useState(watermark || '');

  useEffect(() => {
    const handler = setTimeout(() => {
      if (value.trim() !== '') {
        onWatermarkChange(value);
      } else {
        onWatermarkChange(null);
      }
    }, 1000); // 1 second debounce

    return () => clearTimeout(handler); // Cleanup on re-render
  }, [value, onWatermarkChange]);
  return (
    <Box sx={styles.container}>
      <FormControlLabel
        sx={styles.switchControlLabel}
        control={<Switch size="small" inputProps={styles.controls} />}
        label={
          <span
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.stopPropagation();
              }
            }}
            role="button"
            tabIndex={0}
          >
            {messages.applyWatermark}
          </span>
        }
        labelPlacement="start"
        checked={isWatermarkEnabled}
        onChange={(_, checked) => {
          if (!checked) {
            setValue('');
            setIsWatermarkEnabled(false);
            onWatermarkChange(null);
          } else {
            setIsWatermarkEnabled(true);
          }
        }}
      />
      <TextField
        value={value}
        onChange={(e) => setValue(e.target.value)}
        sx={styles.textField}
        placeholder={messages.enterWatermarkText}
        disabled={!isWatermarkEnabled}
        inputProps={{
          maxLength: MAX_WATERMARK_LENGTH
        }}
      />
      {isWatermarkEnabled && (
        <Typography variant="caption" sx={styles.watermarkLength}>
          {value.length} / {MAX_WATERMARK_LENGTH}
        </Typography>
      )}
    </Box>
  );
};
